import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            黑料视频专区
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            黑料视频在线看，高清画质无需下载，每日更新最新独家视频内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/80 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次播放
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}